module.exports = __webpack_public_path__ + "static/media/discussion_9520385.3c41a65c.svg";